module.exports = __webpack_public_path__ + "static/media/2.388afeb7.jpg";